const OtpVerification = () => {
    return (
        <>
            <div className="container">
                <div className="col-12">
                    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
                        <div className="card shadow-sm " >
                            <div className="card-header">
                                <div className="card-title">Verify OTP</div>
                            </div>
                            <div className="card-body">
                                <form>
                                    <label className="form-label"> Enter OTP</label>
                                    <input
                                        type="text"
                                        placeholder="Enter OTP"
                                        className="form-control "

                                    />
                                    <p className="mt-3 text-danger"></p>
                                    <div className="">
                                        <button className="btn btn-black mt-3 w-100" >
                                            Verify OTP
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OtpVerification;
